import * as React from 'react';

function BaseOfferTag() {
  return (
    <span className='inline-flex min-w-[113px] items-center justify-center border border-[#1D39C4] bg-[#D6E4FF] text-xs leading-5 text-[#1D39C4]'>
      Oferta base
    </span>
  );
}

export { BaseOfferTag };
